import candidateAuthDictionary from '@pages/candidate-auth/i18n/ru/candidate-auth.dic.json';

import verification from '@widgets/verification/i18n/ru/verification.dic.json';

import candidateCreatePassword from '@features/candidate-registration/i18n/ru/create-password.dic.json';
import candidateOTP from '@features/candidate-registration/i18n/ru/otp.dic.json';
import candidateRegistration from '@features/candidate-registration/i18n/ru/registration-form.dic.json';

export const candiateAuth = {
  CANDIDATE_AUTH: candidateAuthDictionary,
  CANDIDATE_CREATE_PASSWORD: candidateCreatePassword,
  CANDIDATE_REGISTRATION: candidateRegistration,
  CANDIDATE_OTP: candidateOTP,
  VERIFICATION: verification,
};

export const candiateAuthNamespaces = Object.keys(candiateAuth);
